import { HttpClient, isHttpError } from '@ubi/js-utils/http'
import { resolveEndpoint } from '@/lib/services'

interface paths {
    'auth/realms/{realm}': {
        get: {
            parameters: {
                path: {
                    realm: string
                }
            }
            responses: {
                200: {
                    content: {
                        'application/json': Record<string, never>
                    }
                }
            }
        }
    }
}

const keycloakClient = new HttpClient<paths>({
    serviceName: 'KeycloakService',
    localNetworkConfiguration: {
        getEndpoint: resolveEndpoint,
    },
})

/**
 * A health check to verify keycloak server is up and the realm exists
 * Returns false is the endpoint is not reachable
 */
export const keycloakHealthCheck = async (realm: string) => {
    try {
        await keycloakClient
            .path('auth/realms/{realm}')
            .method('get')
            .request({ realm })
        return true
    } catch (err) {
        if (!isHttpError(err)) throw err
        return false
    }
}
